/**
 * L2-S13: moved to @miq/utils (misc/lower-no-spaces.ts). This shim keeps the old
 * import path working; new code should import from '@miq/utils'.
 */
export { lowerNoSpaces } from '@miq/utils';
